import React from 'react';
import styles from './AuditionDetailTabs.module.css';

const TABS = [
  { id: 'detail', label: '상세 정보' },
  { id: 'roles', label: '모집 역할' },
  { id: 'producer', label: '제작사 정보' },
];

/**
 * @component AuditionDetailTabs
 * @description 상세 정보 / 모집 역할 / 제작사 정보 탭 네비게이션
 *
 * @param {'detail'|'roles'|'producer'} props.activeTab
 * @param {Function}                    props.onTabChange
 */
function AuditionDetailTabs({ activeTab, onTabChange }) {
  return (
    <nav className={styles.tabs} role="tablist">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
          aria-selected={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}

export default AuditionDetailTabs;
